export default __webpack_public_path__ + "static/media/car3.3e724a50.jpg";